// AUTOGENERATED: DO NOT EDIT

import { Assets } from "pixi.js";
import bubble1 from "../../assets/img//bubble-1.png";
import clownfish from "../../assets/img/fish/clownfish.png";
import goldfish1 from "../../assets/img/fish/goldfish-1.png";
import grayfish1 from "../../assets/img/fish/grayfish-1.png";
import pufferfish1 from "../../assets/img/fish/pufferfish-1.png";
import pufferfish2 from "../../assets/img/fish/pufferfish-2.png";
import pufferfish3 from "../../assets/img/fish/pufferfish-3.png";
import tinyfish1 from "../../assets/img/fish/tinyfish-1.png";
import willemfish1 from "../../assets/img/fish/willemfish-1.png";

export const loadSpritesheets = async () => {
  Assets.load([
    bubble1,
    clownfish,
    goldfish1,
    grayfish1,
    pufferfish1,
    pufferfish2,
    pufferfish3,
    tinyfish1,
    willemfish1,
  ]);
};
